import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

const TYPE_LABELS = {
  DISCOUNT_LEVEL_UP: 'Новий рівень знижки',
  PROMO_CODE_GRANTED: 'Промокод',
  PROMO_CODE_EXPIRING: 'Закінчується промокод',
  PRODUCT_BACK_IN_STOCK: 'Товар з\'явився в наявності'
};

const formatNotificationDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    return d.toLocaleString('uk-UA', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch {
    return dateStr;
  }
};

const NotificationsTab = ({ onCountChange }) => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [markingId, setMarkingId] = useState(null);

  const token = localStorage.getItem('token');

  const loadNotifications = () => {
    if (!token) return;
    setLoading(true);
    axios
      .get('/api/v1/user/notifications', { headers: { Authorization: token }, params: { limit: 100 } })
      .then((res) => {
        if (res.data && res.data.data) setList(res.data.data);
        if (typeof onCountChange === 'function') {
          axios.get('/api/v1/user/notifications/count', { headers: { Authorization: token } })
            .then((r) => { if (r.data && r.data.data) onCountChange(r.data.data); })
            .catch(() => {});
        }
      })
      .catch(() => setList([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadNotifications();
  }, []);

  const markAsRead = (id) => {
    if (!token || markingId) return;
    setMarkingId(id);
    axios
      .patch(`/api/v1/user/notifications/${id}/read`, {}, { headers: { Authorization: token } })
      .then(() => {
        setList((prev) => prev.map((n) => (n.id === id ? { ...n, status: 'READ', readAt: new Date().toISOString() } : n)));
        if (typeof onCountChange === 'function') {
          axios.get('/api/v1/user/notifications/count', { headers: { Authorization: token } })
            .then((r) => { if (r.data && r.data.data) onCountChange(r.data.data); })
            .catch(() => {});
        }
      })
      .finally(() => setMarkingId(null));
  };


  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5 personal-cabinet-tab-content">
        <Spinner animation="border" variant="secondary" />
      </div>
    );
  }

  if (list.length === 0) {
    return (
      <div className="py-4 text-muted personal-cabinet-tab-content">
        <h5 className="font-weight-bold mb-3 text-center">Сповіщення</h5>
        <p className="mb-0">У вас поки немає сповіщень.</p>
      </div>
    );
  }

  return (
    <div className="notifications-tab personal-cabinet-tab-content">
      <h5 className="font-weight-bold mb-3 text-center">Сповіщення</h5>
      <ul className="list-unstyled mb-0">
        {list.map((n) => (
          <li
            key={n.id}
            className={`border rounded mb-2 p-3 ${n.status === 'UNREAD' ? 'shadow' : ''}`}
            style={{
              border: '1px solid #dee2e6',
              ...(n.status === 'UNREAD' && { borderLeft: '5px solid #007bff' }),
              backgroundColor: n.status === 'UNREAD' ? '#e7f1ff' : '#f8f9fa'
            }}
          >
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-2">
              {n.status === 'UNREAD' && (
                <Button
                  variant="link"
                  size="sm"
                  className="d-none d-md-block p-0 text-decoration-none ml-md-auto order-md-2 align-self-start"
                  onClick={() => markAsRead(n.id)}
                  disabled={markingId === n.id}
                >
                  {markingId === n.id ? '...' : 'Позначити прочитаним'}
                </Button>
              )}
              <div className="order-2 order-md-1 mb-3" style={{ fontSize: '1.05rem' }}>
                <span className="font-weight-bold text-dark d-block d-md-inline">{TYPE_LABELS[n.type] || n.type}</span>
                <span className="text-muted d-block d-md-inline mt-0 mt-md-0 ml-md-1" style={{ fontSize: '0.95rem' }}>
                  {formatNotificationDate(n.createdAt)}
                </span>
              </div>
            </div>
            {n.title && <h6 className="mt-1 mb-2">{n.title}</h6>}
            <div
              className="notification-body"
              dangerouslySetInnerHTML={{ __html: n.body || '' }}
            />
            {n.linkUrl && n.linkText && (
              <a href={n.linkUrl} className="btn btn-dark mt-2 px-3 py-2">
                {n.linkText}
              </a>
            )}
            {n.status === 'UNREAD' && (
              <Button
                variant="link"
                size="sm"
                className="d-md-none d-block p-0 text-decoration-none mt-3 text-left w-100"
                onClick={() => markAsRead(n.id)}
                disabled={markingId === n.id}
              >
                {markingId === n.id ? '...' : 'Позначити прочитаним'}
              </Button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NotificationsTab;
